const oneClick={
    bind(el, binding) {
        // 绑定点击事件，就是所谓的一键 copy 啦
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true;
                setTimeout(() => {
                    el.disabled = false;
                }, binding.value || 1000);
            }
        });
    },
}

export default oneClick



// WEBPACK FOOTER //
// ./src/common/directives/oneClick.js